/**
 * @param {angular.$scope} $scope
 * @param {Object} messageResolve
 * @param {angular.Service} AppointmentModal
 * @constructor
 */
var MailCtrl = function ($scope,
                         messageResolve,
                         ModalService) {

    this._ModalService = ModalService;

    $scope.setMessage(messageResolve);
    $scope.message = messageResolve;

    console.log(messageResolve);
};


/**
 * @param {Object} appointment
 */
MailCtrl.prototype.openAppointment = function (appointment) {
    appointment.start = new Date(appointment.start);
    appointment.end = new Date(appointment.end);

    this._ModalService.openAppointmentModal(appointment);
}

module.exports = MailCtrl;
